import {CoreFlowState} from 'core/core-flow-state';

/**
 * @module SalesFlow/evolved/view
 */

declare var $: JQueryStatic;

import Injector from 'core/injector';
import { Constants } from 'core/constants';
import AttributeRepo from 'model/repo/attribute-repo';
import { ViewEvolvedElementInsuranceDetailOverlay } from 'view-evolved/element/shared/view-evolved--element-shared--insurance-detail-overlay';
import DeviceTile from 'view-evolved/element/vvl/view-evolved--element-vvl--device-tile';
import DeviceList from 'view/element/shared/device-list';
import { ActiveFilterOptionsByGroup } from 'view/element/shared/filter/filters';
import DeviceOffer from 'view/view/shared/offer/device-offer';
import BntDeviceFlowService from 'service/bnt/bnt-device-flow-service';

export class ViewEvolvedElementDeviceList extends DeviceList {

    // protected _tileHbs: string;

    protected _attributeRepo: AttributeRepo;

    protected _deviceTile: DeviceTile[];

    private _insuranceDetailOverlay: ViewEvolvedElementInsuranceDetailOverlay;

    protected _focusAtomicDeviceId: number;

    constructor (injector: Injector, attributeRepo: AttributeRepo, focusAtomicDeviceId: number, tileHbs: string) {
        super(injector);

        this._tileHbs = tileHbs;
        this._attributeRepo = attributeRepo;
        this._focusAtomicDeviceId = focusAtomicDeviceId;
        this._insuranceDetailOverlay = new ViewEvolvedElementInsuranceDetailOverlay(this._injector);

    }

    public events (): void {

        let selector;

        this._element.on('click', '.vll-device-accordion-toggle', (evt) => {
            setTimeout(() => {
                this._slider.updateHeight();
            }, 800);
        });

        this._insuranceDetailOverlay.bind();

        // @TODO deviceTiles are only a workaround

        this._deviceTile = this._viewOffers.map((deviceOffer: DeviceOffer): DeviceTile => {

            return new DeviceTile(
                this.getElement().find('.device-module-tile[data-device-id="' + deviceOffer.atomicDevice.device.id + '"]'),
                deviceOffer,
                this.getInjector()
            );

        });

        selector = '.device-module-tile .selectionRadio';
        this.getElement().off('click', selector).on('click', selector, (evt) => {

            const deviceTile: JQuery = $(evt.currentTarget).parents('.device-module-tile');

            if (true === deviceTile.hasClass('selected')) {
                return true;
            }

            const deviceId = parseInt(deviceTile.attr('data-atomic-device-id'), 10);
            this._coreFlowState.setAtomicDeviceId(deviceId);
            this._coreFlowState.lockDevice();

        });

        selector = '.device-module-tile .selectionCheck';
        this.getElement().off('click', selector).on('click', selector, (evt) => {
            const deviceTile = evt.currentTarget.parentElement.parentElement;
            const atomicDeviceId = parseInt(deviceTile.dataset.atomicDeviceId, 10);

            if (atomicDeviceId === this._selectedAtomicDeviceId) {
                this._selectedAtomicDeviceId = undefined;
                this._coreFlowState.setAtomicDeviceId(undefined);
                this._coreFlowState.unlockDevice();
            } else {
                this._selectedAtomicDeviceId = atomicDeviceId;
                this._coreFlowState.setAtomicDeviceId(atomicDeviceId);
                this._coreFlowState.lockDevice();
            }
        });

        this.getInjector().getEvent().listen('atomicDeviceId@changed', (eventObject: JQueryEventObject, data: any) => {
            const atomicDeviceId = data.atomicDeviceId;

            $('.tradeinBox .checkBox').removeClass('selected');

            this.getElement().find('.device-module-tile.selected').removeClass('selected');
            if (undefined === atomicDeviceId) {
                return;
            }

            this.getElement().find('.device-module-tile[data-atomic-device-id="' + atomicDeviceId + '"]').addClass('selected');
            this._slider.showSelectedElement();

        });

        this.getInjector().getEvent().listen('atomicDeviceId@changedByInsurance', (eventObject: JQueryEventObject, data: any) => {
            const atomicDeviceId = data.atomicDeviceId;

            this.getElement().find('.device-module-tile.selected').removeClass('selected');

            if (undefined === atomicDeviceId) {
                return;
            }

            this.getElement().find('.device-module-tile[data-atomic-device-id="' + atomicDeviceId + '"]').addClass('selected');

        });

        this.getInjector().getEvent().listen('filters@changed', (eventObject: JQueryEventObject, activeFilterOptionsByGroup: ActiveFilterOptionsByGroup) => {
            this.filterList(activeFilterOptionsByGroup);

        });

        selector = '.tradeinBox .checkBox .i-check, .tradeinBox .checkBox .pseudo-checkbox-label';
        this._element.off('click', selector).on('click', selector, (evt) => {

            const deviceTile: JQuery = $(evt.currentTarget).parents('.device-module-tile');

            const deviceId = parseInt(deviceTile.attr('data-atomic-device-id'), 10);

            const target = $(evt.currentTarget).parents('.checkBox');

            let selected = false;

            if (!target.hasClass('selected')) {
                /**
                 * save information in flow
                 */
                // this.getInjector().getFlow().optionalServiceIds.addElement(Constants.TradeInDiscount_Id);
                /**
                 * urgh - if there is any better solution, please fix it
                 */
                const currentDevice = target.closest('.device-module-tile');
                if ( !(currentDevice.hasClass('selected')) ) {
                    currentDevice.find('.selectionCheck').trigger('click');
                }
                /*
                this.getInjector().getEvent().trigger('atomicDeviceId@changed', {
                    atomicDeviceId: deviceId
                }); */

                selected = true;
            }

            target.toggleClass('selected');

            this.getInjector().getEvent().trigger('tradein@changed', {
                atomicDeviceId: deviceId,
                selected
            });

            this.getInjector().getEvent().trigger('tradeinCheckboxTracking@changed', {
                tradeinCheckboxIsChecked: selected,
                isVvlFlow: false
            });

        });

    }

    public update (devices: DeviceOffer[]): void {

        for (const device of devices) {

            for (const tile of this._deviceTile) {

                if (device.atomicDeviceId === tile.getDeviceOffer().atomicDeviceId) {

                    tile.setDeviceOffer(device);

                }

            }

        }

        BntDeviceFlowService.toggleConsumerOrYoungBanner(this._injector.getFlowState().getSalesChannel(), this._injector.getFlowState().getHardwareOnly());

        super.update(devices);

    }

    public render (devices: DeviceOffer[]): string {
        super.render(devices);

        const customer = this._coreFlowState.customer;
        if (customer.isSimOnlyVvlAllowed) {
            this.getElement().find('.selectionRadio').replaceWith(
                this.getInjector().getTemplates().render('selection-check', '', 'partials')
            );
        }

        const atomicDeviceId = this._coreFlowState.getAtomicDeviceId();

        if (undefined !== atomicDeviceId) {
            const subscriptionId = this._coreFlowState.getSubscriptionId();

            const subscription = this.getInjector().getReposSupervisor().getSubscriptionRepo().getSubscription(
                subscriptionId
            );

            let deviceRepo;
            if (Constants.OrderType_Voice === this.getInjector().getFlowState().getOrderType()) {
                deviceRepo = this.getInjector().getReposSupervisor().getPurchasableDeviceRepo();
            } else {
                deviceRepo = this.getInjector().getReposSupervisor().getPurchasableTabletRepo();
            }

            const atomicDevice = deviceRepo.getAtomicDevice(
                atomicDeviceId,
                this._coreFlowState.getSalesChannel(),
                subscription
            );

            if (undefined !== atomicDevice) {
                this._element.find('[data-device-id="' + atomicDevice.getDevice().id + '"]').addClass('selected');
            }

        }

        BntDeviceFlowService.toggleConsumerOrYoungBanner(this._injector.getFlowState().getSalesChannel(), this._injector.getFlowState().getHardwareOnly());

        return '';
    }

    private bindSlider (): void {

        let focusAtomicDeviceId: number;

        if (undefined !== this._coreFlowState.getAtomicDeviceId()) {
            focusAtomicDeviceId = this._coreFlowState.getAtomicDeviceId();
        }
        else if (undefined !== this._focusAtomicDeviceId) {
            focusAtomicDeviceId = this._focusAtomicDeviceId;
        }

        this._slider.bind(
            $('.device-module-tile[data-atomic-device-id="' + focusAtomicDeviceId + '"]')
        );

    }

    public bind (devices: DeviceOffer[]): void {

        super.bind(devices);

        this.bindSlider();
    }

}
